import { useEffect, useState, Fragment } from 'react';
import Footer from './components/Footer/Footer';
import routes from '../../router/AppRoutes';
import Router from '../../router/Router';
import SubHeader from './components/SubHeader/SubHeader';
import {
    LayoutContainer,
    LayoutBodyContainer,
    LayoutBodyDivider,
    LayoutFooterDivider
} from './styles/AppLayoutStyles';
import ScrollToTopWithRouter from '../../router/ScrollToTopWithRouter';
import { useLocation } from 'react-router-dom';
import Header from './components/Header/Header';

const AppLayout = ({ children }) => {
    const [freeSpaceLayout, setFreeSpaceLayout] = useState(true);
    const location = useLocation();
    const AppRoutes = routes.filter((route) => route.layout === '/app')

    useEffect(() => {
        //TO DO ADD ARRAY WITH PATHS FOR USE WITHOUT SUBHEADER  
        if (location.pathname === "/app/home") {
               setFreeSpaceLayout(true)
        } else {
               setFreeSpaceLayout(false)
        }

    }, [location]);

    return (
        <LayoutContainer>
            <Header />
            {!freeSpaceLayout &&
                <Fragment>
                    <SubHeader />
                    <LayoutBodyDivider />
                </Fragment>
            }
            <LayoutBodyContainer layoutActive={!freeSpaceLayout}>
                <ScrollToTopWithRouter>
                    <Router routes={AppRoutes} />
                </ScrollToTopWithRouter>
            </LayoutBodyContainer>
            <LayoutFooterDivider />
            <Footer />
        </LayoutContainer>

    );
}

export default AppLayout;